//@flow
import api from '../Utils/apiBuilder';
import Constants from '../constants';
import type { FriendBuyVisitor } from '../Utils/friendbuyV2';

export type OrderParams = {
  quote_id:string,
  error_constant?:string,
  friendbuy_visitor?:FriendBuyVisitor,
};

export default {
  getOrders() {
    return api('orders').get().dispatch(Constants.GET_ORDERS_SUCCESS);
  },

  getOrder(orderId:string) {
    return api('orders', orderId).get().dispatch(Constants.GET_ORDER_SUCCESS);
  },

  createOrder(order:OrderParams) {
    const errorConstant = order.error_constant || Constants.CREATE_ORDER_SUCCESS;
    return api('orders').post(order)
      .dispatch(Constants.CREATE_ORDER_SUCCESS, errorConstant);
  },
};
